import { render, staticRenderFns } from "./ComponentCurrentLiveTime.vue?vue&type=template&id=08f50de8"
import script from "./ComponentCurrentLiveTime.vue?vue&type=script&lang=js"
export * from "./ComponentCurrentLiveTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports